<ng-template #template let-anchor>
    <span>{{ anchor.nativeElement.innerText }}</span>
</ng-template>

<div class="cg3-select-field">
    <div class="cg3-host-text-field">
        <div class="cg3-text-field">
            <div class="cg3-host-form-field">
                <div class="cg3-form-field">
                    @if (label) {
                        <div class="cg3-host-form-field-header">
                            <div class="cg3-form-field-header cg3-text-field-header">
                                <div class="cg3-host-form-field-label">
                                    <form-field-label-pds3>
                                        <span>{{ label | wkTranslate }}</span>
                                    </form-field-label-pds3>
                                </div>
                            </div>
                        </div>
                    }

                    <div class="cg3-host-form-field-body">
                        <div class="cg3-form-field-body cg3-text-field-body cg3-form-field-body-{{ size }}">
                            <div class="cg3-form-field-body-container">
                                <div class="cg3-host-select-field-body">
                                    <div
                                        class="cg3-select-field-body"
                                        kendoTooltip
                                        #tt="kendoTooltip"
                                        [tooltipTemplate]="template"
                                        filter="li.k-list-item, .k-input-inner"
                                        showOn="none"
                                        (mouseover)="onMouseOver($event)"
                                        (mouseleave)="onMouseLeave($event)"
                                        [tooltipClass]="'kendo-combobox-wrapper-tooltip'"
                                    >
                                        <kendo-combobox
                                            [data]="filteredData"
                                            [value]="value"
                                            (valueChange)="handleValueChange($event)"
                                            [valuePrimitive]="true"
                                            [textField]="textField"
                                            [valueField]="valueField"
                                            [placeholder]="placeholder"
                                            [popupSettings]="{ appendTo: 'component', popupClass: 'combobox-wrapper-popup', animate: false }"
                                            fillMode="none"
                                            rounded="none"
                                            [size]="size"
                                            [virtual]="
                                                virtual
                                                    ? {
                                                          itemHeight: 32,
                                                          pageSize: 30,
                                                      }
                                                    : false
                                            "
                                            [listHeight]="196"
                                            [adaptiveMode]="virtual ? 'none' : 'auto'"
                                            [filterable]="true"
                                            (filterChange)="onFilterChange($event)"
                                            [disabled]="disabled"
                                            [tabindex]="disabled ? -1 : 0"
                                            [clearButton]="false"
                                            data-input="true"
                                            class="wk-combobox"
                                        >
                                            <ng-template kendoComboBoxItemTemplate let-dataItem>
                                                <div class="combobox-wrapper-item">
                                                    {{ dataItem | nestedValue: textField | wkTranslate }}
                                                </div>
                                            </ng-template>

                                            <ng-template kendoComboBoxNoDataTemplate>
                                                @if (noDataText) {
                                                    <span class="text-resizing">
                                                        {{ noDataText }}
                                                    </span>
                                                }
                                            </ng-template>
                                        </kendo-combobox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
